import { Col, Container, Row } from "react-bootstrap";
import LoginButton from "./LoginButton";

export default function LoginPrompt({ message }: { message?: string }) {
  return (
    <div className="login-prompt">
      <Container>
        <Row>
          <Col lg={4} className="login-prompt-content">
            {message && <div>{message}</div>}
            <div className="login-prompt-buttons">
              <LoginButton className="btn btn-primary" signup />
              <LoginButton className="as-link" />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
